function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".badge{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0.75 0.75)"
}, React.createElement("line", {
  className: "badge",
  x2: 4,
  transform: "translate(10 9.133)"
}), React.createElement("line", {
  className: "badge",
  x2: 4,
  transform: "translate(10 12.133)"
}), React.createElement("path", {
  className: "badge",
  d: "M5.033,3.5h-3.4A1.133,1.133,0,0,0,.5,4.633v10.2a1.133,1.133,0,0,0,1.133,1.133H16.367A1.133,1.133,0,0,0,17.5,14.833V4.633A1.133,1.133,0,0,0,16.367,3.5h-3.4",
  transform: "translate(-0.5 -0.1)"
}), React.createElement("rect", {
  className: "badge",
  width: 4,
  height: 3,
  transform: "translate(3 9.133)"
}), React.createElement("path", {
  className: "badge",
  d: "M8.2.5h0A1.7,1.7,0,0,1,9.9,2.2V6.167H6.5V2.2A1.7,1.7,0,0,1,8.2.5Z",
  transform: "translate(0.3 -0.5)"
}));

const SvgBadge = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 18.5,
    height: 17.367,
    viewBox: "0 0 18.5 17.367",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgBadge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/badge.9b0e7461.svg";
export { ForwardRef as ReactComponent };